var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28247 21.1362C3.28247 21.1362 8.59641 16.7584 11.0984 16.9189L12.3494 30.3566L2.8175 31.7624L3.28801 21.1362H3.28247Z",
    fill: "#CD566C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5575 18.6069C5.5575 18.1484 5.92923 17.7767 6.3878 17.7767H9.72561C10.7931 17.7767 11.663 18.6465 11.663 19.7138V28.6132C11.663 29.6805 10.7931 30.5503 9.72561 30.5503H6.3878C5.92923 30.5503 5.5575 30.1786 5.5575 29.7201V18.6069ZM7.2181 19.437V28.8899H9.72561C9.87594 28.8899 10.0024 28.7635 10.0024 28.6132V19.7138C10.0024 19.5635 9.87594 19.437 9.72561 19.437H7.2181Z",
    fill: "#060606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59798 19.437C2.52878 19.437 1.6606 20.3051 1.6606 21.3741V26.9529C1.6606 28.0219 2.52878 28.8899 3.59798 28.8899H5.55749V19.437H3.59798ZM0 21.3741C0 19.3881 1.61166 17.7767 3.59798 17.7767H6.38779C6.84636 17.7767 7.2181 18.1484 7.2181 18.6069V29.7201C7.2181 30.1786 6.84636 30.5503 6.38779 30.5503H3.59798C1.61166 30.5503 0 28.9389 0 26.9529V21.3741Z",
    fill: "#060606"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4425 29.7146C29.4425 30.1731 29.0708 30.5448 28.6122 30.5448H25.2744C24.2069 30.5448 23.337 29.675 23.337 28.6077V19.7083C23.337 18.641 24.2069 17.7712 25.2744 17.7712H28.6122C29.0708 17.7712 29.4425 18.1429 29.4425 18.6014V29.7146ZM27.7819 28.8844V19.4315H25.2744C25.1241 19.4315 24.9976 19.558 24.9976 19.7083V28.6077C24.9976 28.758 25.1241 28.8844 25.2744 28.8844H27.7819Z",
    fill: "#060606"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.402 28.8844C32.4712 28.8844 33.3394 28.0164 33.3394 26.9474V21.3686C33.3394 20.2996 32.4712 19.4315 31.402 19.4315H29.4425V28.8844H31.402ZM35 26.9474C35 28.9334 33.3883 30.5448 31.402 30.5448H28.6122C28.1536 30.5448 27.7819 30.1731 27.7819 29.7146V18.6014C27.7819 18.1429 28.1536 17.7712 28.6122 17.7712H31.402C33.3883 17.7712 35 19.3826 35 21.3686V26.9474Z",
    fill: "#060606"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5027 1.66034C15.2219 1.66034 13.0844 2.2678 11.2487 3.33068C10.8519 3.56044 10.3439 3.42506 10.1141 3.0283C9.88432 2.63153 10.0197 2.12363 10.4165 1.89387C12.4999 0.687615 14.9236 0 17.5027 0C25.3291 0 31.6677 6.34361 31.6677 14.1627V18.6069C31.6677 19.0654 31.296 19.4371 30.8374 19.4371C30.3788 19.4371 30.0071 19.0654 30.0071 18.6069V14.1627C30.0071 7.26014 24.4115 1.66034 17.5027 1.66034Z",
    fill: "#060606"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12109 4.65628C8.4625 4.96237 8.49109 5.48723 8.18494 5.82858C6.20193 8.03966 4.99837 10.96 4.99837 14.1627V18.6069C4.99837 19.0654 4.62663 19.4371 4.16807 19.4371C3.70951 19.4371 3.33777 19.0654 3.33777 18.6069V14.1627C3.33777 10.5359 4.70261 7.22442 6.94861 4.72012C7.25475 4.37877 7.77969 4.35019 8.12109 4.65628Z",
    fill: "#060606"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8374 28.8899C31.2959 28.8899 31.6677 29.2616 31.6677 29.7201V31.945C31.6677 33.6321 30.2996 35 28.6122 35H19.7224C19.2638 35 18.8921 34.6283 18.8921 34.1698C18.8921 33.7113 19.2638 33.3397 19.7224 33.3397H28.6122C29.3824 33.3397 30.0071 32.7151 30.0071 31.945V29.7201C30.0071 29.2616 30.3788 28.8899 30.8374 28.8899Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.45b4cb524b6bae93a150b5cc2c7c5b0a.svg";
export { ForwardRef as ReactComponent };